export function dateFormatter(str: string): string {
  if (!str) return "";

  if (str.length > 10) {
    return str.slice(0, 10);
  }

  return str;
}
